import React, { useEffect, useState } from "react";
import GoogleLoginComponent from "./components/Login/GoogleLoginComponent";
import { googleLogout } from "@react-oauth/google";
import './App.css';
import { EmployeeProvider } from './utils/EmpDetails/EmployeeProvider';
import SearchBar from './SearchBar/SearchBar';
import { AppProvider } from './context/Context';
import CallDetails from './components/CallDetails/CallDetails';
import { useLocation, useNavigate } from "react-router-dom";
import getIP from "./utils/EmpDetails/getIP";
import getCookie from "./utils/GetCookie/getCookie";
import { urlDomain } from "./config/constant";

// Module-level: coalesces concurrent /protected calls into one request.
// Cleared after settling so a hard-refresh always hits the network.
let _protectedPromise = null;

function App() {
  const [user, setUser] = useState(undefined); // Start with undefined instead of null
  const [ip, setIp] = useState(null);
  const [loginMessage, setLoginMessage] = useState("")
  const navigate = useNavigate(); // Initialize useNavigate
  const apiDomain = urlDomain();
  const location = useLocation();
  const currentPath = location.pathname;
  // Redirect only when user is on entry pages
  const isEntryPage = ["/", "/login.php"].includes(currentPath) || currentPath.startsWith("/?msg=");
  useEffect(() => {
    if (_protectedPromise) return;

    _protectedPromise = fetch(`${apiDomain}/protected`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setUser(data.user);
          const currentPath = location.pathname;
          const currentSearch = location.search;
          const previousPath = location.pathname + location.search;


          if (!isEntryPage && currentPath !== "/api/data_dump") {
            localStorage.setItem("previousPathUrl", previousPath);
          }

          if (isEntryPage) {
            const savedUrl = localStorage.getItem("previousPathUrl") || "";
            const isInvalidSavedUrl =
              savedUrl === "/" ||
              savedUrl === "/login.php" ||
              savedUrl.includes("msg=1") ||
              savedUrl.includes("msg=2") ||
              savedUrl === "";

            const defaultUrl = `/api/html?empid=${data.user.empid}`;

            navigate(isInvalidSavedUrl ? defaultUrl : savedUrl);
          }
        } else {
          if (!isEntryPage && currentPath !== "/api/data_dump") {
            localStorage.setItem("previousPathUrl", location.pathname + location.search);
          }
          setUser(null);
          if(location.search === ""){
            navigate("/");
          }else if (location.search === "?msg=1") {
            setLoginMessage("You have successfully logged out.");
            navigate("/?msg=1");
          } else if(location.search === "?msg=2") {
            setLoginMessage("Your Session Has Expired. Please Login Again.");
            navigate("/?msg=2");
          }else{
            setLoginMessage("Your Session Has Expired. Please Login Again.");
            navigate("/?msg=2");
          }
        }
      })
      .catch(() => {
        setUser(null);
        navigate("/?msg=2");
      })
      .finally(() => {
        _protectedPromise = null;
      });
  }, []);

  useEffect(() => {
    getIP()
      .then((ipResponse) => {
        const fetchedIp = ipResponse.data.ip || getCookie("CCIP");
        setIp(fetchedIp);
      })
      .catch((ipError) => {
        console.error("Error fetching IP address:", ipError);
      });
  }, []);

  const handleLogout = () => {
    googleLogout();
    fetch(`${apiDomain}/auth/logout`, {
      method: "POST",
      credentials: "include",
    }).then(() => {
      setUser(null);
      navigate("/?msg=1");
      setLoginMessage("You have successfully logged out.");
    });
  };

  // Only render after user is either set or confirmed as null
  if (user === undefined) {
    return null; // Or a blank screen while checking session
  }

    return (
      <div>
        {user ? (
          <EmployeeProvider>
            <AppProvider>
              {document.location.pathname === "/api/data_dump" ? (
                <CallDetails empid={user?.empid} ak="" />
              ) : (
                <SearchBar handleLogout={handleLogout} />
              )}
            </AppProvider>
          </EmployeeProvider>
        ) : (
          <GoogleLoginComponent onLoginSuccess={setUser} onLogout={handleLogout} ip={ip} loginMessage={loginMessage} setLoginMessage={setLoginMessage} />
        )}
      </div>
    );
  }

export default App;
